export const productCardEvents = {
  cardInView: "product-list:card-in-view",
  cardClick: "product-list:card-click",
  colourSwatchClicked: "product-list:colour-swatch:clicked",
  energyRatingClicked: "product-list:energy-rating:clicked",
  promoMessagesViewed: "product-list:promo-messages:viewed",
  quickViewOpened: "product-list:quick-view:opened",
  quickViewUpdated: "product-list:quick-view:updated",
  quickViewAddToBasket: "product-list:quick-view:add-to-basket",
  removeProduct: "product-list:remove-product",
  quantityWantedUpdate: "product-list:quantity-wanted-update",
  addToWishlist: "product-list:add-to-wishlist",
  ctaAddToBasket: "product-list:cta:add-to-basket",
  ctaEmailMe: "product-list:cta:email-me",
  ctaMoreInformation: "product-list:cta:more-information",
  ctaViewOptions: "product-list:cta:view-options",
  ctaInStoreOnly: "product-list:cta:in-store-only",
  ctaOutOfStock: "product-list:cta:out-of-stock",
  ctaWellBeInTouch: "product-list:cta:well-be-in-touch",
  ctaGoToBasket: "product-list:cta:go-to-basket",
  ctaViewRange: "product-list:cta:view-range",
  onlineStockDataError: "product-list:online-stock-error",
  variantChange: "product-list:variant-change",
} as const;

export type EventName =
  (typeof productCardEvents)[keyof typeof productCardEvents];
